export class JobApplyObject {
  LaunchedFrom: string;
  JobId: number;
  eQuestSource: string;
  ApplicationId: number;
  IsDrafted: boolean;
}



// WEBPACK FOOTER //
// ../UI/src/app/shared/job/job-apply-object.dto.ts